import * as React from 'react';
import * as MenuConfig from '../../../../typings/menu';
import { StyledHeaderSection } from '../styles';
import HeaderLogo from '../../../../containers/MenuManager/Header/Logo';
import HeaderButton from '../../../../containers/MenuManager/Header/HeaderButton';
import ShareButton from '../../../../containers/Share/ShareButton';
import SearchButton from '../../../../containers/DriveItemList/Search/Button';
import { Api } from '../../../../typings/api';
import DriveItemDownloadButton from '../../../../containers/DriveItem/DownloadButton';
import { DriveItemListOrigin } from '../../../../containers/DriveItemListPage/constants';
import RoutesUtils from '../../../../utils/routes';
import { ActionButtonStyle } from '../../../../utils/driveItem';
import { ShareOrigin } from '../../../../containers/Share/actions';
import { StyledTitle } from '../../../Title/styles';
import { Translate } from 'react-redux-i18n';
import CancelButton from '../HeaderButton/CancelButton';
import { CancelActionOrigin } from '../../../../containers/MenuManager/constants';
import ButtonCreate from '../../../../containers/ButtonCreate';
import ButtonCreateNote from '../../../../containers/ButtonCreateNote';
import BackToPublication from '../../../../containers/BackToPublication';
import UpdateFolderTreeHeaderButton from '../../../../containers/MenuManager/Header/UpdateFolderTreeButton';

interface HeaderSectionProps {
	position: MenuConfig.MenuPosition;
	menuItems: MenuConfig.MenuItem[];
	driveItems?: Api.DriveFolderInfo[];
	privateDirId: number | undefined;
	sharedDirId: number | undefined;
	isButtonCreateAvailable: boolean;
}

class HeaderSection extends React.Component<HeaderSectionProps, {}> {
	render() {
		const { menuItems, position } = this.props;

		return (
			<StyledHeaderSection position={position}>
				{menuItems
					? menuItems.map((menuItem, index) => this.getMenuItemElement(menuItem, `header-button-${index}`))
					: null
				}
			</StyledHeaderSection>
		);
	}

	getMenuItemElement({ type, icon, label, target, options }: MenuConfig.MenuItem, key: string) {
		const { driveItems, privateDirId, sharedDirId, isButtonCreateAvailable, position } = this.props;
		let itemArgs;

		switch (type) {
			case MenuConfig.MenuItemType.Home:
				itemArgs = {
					icon: icon || 'iconset_home',
					label: label || 'messages.home',
					type,
					target: RoutesUtils.getPathHome(),
				};
				break;
			case MenuConfig.MenuItemType.Gallery:
				itemArgs = {
					icon: icon || 'iconset_image',
					label: label || 'messages.my_gallery',
					type,
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, null),
				};
				break;
			case MenuConfig.MenuItemType.BurgerButton:
				itemArgs = {
					icon: icon || 'iconset_uprez_menu',
					label: label || 'messages.menu',
					type,
				};
				break;
			case MenuConfig.MenuItemType.Logo:
				return (
					<HeaderLogo
						key={key}
						icon={icon}
						label={label}
					/>
				);
			case MenuConfig.MenuItemType.DownloadButton:
				return (
					<DriveItemDownloadButton
						key={key}
						driveItems={driveItems ? driveItems : []}
						style={ActionButtonStyle.Icon}
						icon={icon}
						label={label}
					/>
				);
			case MenuConfig.MenuItemType.ShareButton:
				return (
					<ShareButton
						key={key}
						driveItems={driveItems ? driveItems : []}
						shareOrigin={ShareOrigin.Selection}
						icon={icon}
						label={label}
						isInMenuBar={true}
					/>
				);
			case MenuConfig.MenuItemType.SearchButton:
				return (
					<SearchButton
						key={key}
						icon={icon}
						label={label}
					/>
				);
			case MenuConfig.MenuItemType.UpdateFolderTreeButton:
				return (
					<UpdateFolderTreeHeaderButton
						key={key}
						icon={icon}
						label={label}
					/>
				);
			case MenuConfig.MenuItemType.CancelButton:
				return (
					<CancelButton
						key={key}
						actionOrigin={target as CancelActionOrigin}
					/>
				);
			case MenuConfig.MenuItemType.Selection:
				itemArgs = {
					icon: icon || 'iconset_uprez_selection',
					label: label || 'messages.my_selection',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Selection, null),
					type: MenuConfig.MenuItemType.Selection,
				};
				break;
			case MenuConfig.MenuItemType.Title:
				return (
					<StyledTitle key={key}>
						<Translate value={label} />
					</StyledTitle>
				);
			case MenuConfig.MenuItemType.New:
				itemArgs = {
					icon: icon || 'iconset_news',
					label: label || 'messages.new',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.New, null),
				};
				break;
			case MenuConfig.MenuItemType.Documents:
				itemArgs = {
					icon: icon || 'iconset_uprez_documents',
					label: label || 'messages.my_documents',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, String(privateDirId)),
					type: MenuConfig.MenuItemType.Documents,
				};
				break;
			case MenuConfig.MenuItemType.SharedWithMe:
				itemArgs = {
					icon: icon || 'iconset_shared_with_me',
					label: label || 'messages.shared_with_me',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Folder, String(sharedDirId))
				};
				break;
			case MenuConfig.MenuItemType.Downloads:
				itemArgs = {
					icon: icon || 'iconset_uprez_download',
					label: label || 'messages.downloads',
					target: RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Downloads, null),
				};
				break;
			case MenuConfig.MenuItemType.Parameters:
				itemArgs = {
					icon: icon || 'iconset_parameters',
					label: label || 'messages.parameters',
					target: RoutesUtils.getPathParameters(),
				};
				break;
			case MenuConfig.MenuItemType.Link:
				itemArgs = {
					type: MenuConfig.MenuItemType.Link,
					label: label || 'Link',
					icon: icon || 'iconset_link',
					target,
				};
				break;
			case MenuConfig.MenuItemType.Asset:
				itemArgs = {
					type: MenuConfig.MenuItemType.Asset,
					label: label || 'Asset',
					icon: icon || 'iconset_file',
					target,
				};
				break;
			case MenuConfig.MenuItemType.Folder:
				itemArgs = {
					type: MenuConfig.MenuItemType.Folder,
					label: label || 'Folder',
					icon: icon || 'iconset_folder',
					target,
				};
				break;
			case MenuConfig.MenuItemType.Page:
				itemArgs = {
					type: MenuConfig.MenuItemType.Page,
					label: label || 'Page',
					icon: icon || 'iconset_page',
					target,
				};
				break;
			case MenuConfig.MenuItemType.CreateButton:
				return isButtonCreateAvailable
					? (
						<ButtonCreate
							key={key}
							options={options as MenuConfig.CreateButtonOption[]}
							position={position}
						/>
					)
					: null;
			case MenuConfig.MenuItemType.CreateNote:
				return (
					<ButtonCreateNote
						key={key}
						position={position}
						label={label}
						icon={icon}
					/>
				);
			case MenuConfig.MenuItemType.BackToPublication:
				return (
					<BackToPublication
						key={key}
						position={position}
						label={label}
						icon={icon}
					/>
				);
		}

		if (itemArgs) {
			return (
				<HeaderButton
					{...itemArgs}
					key={key}
				/>);
		}

		return null;
	}
}

export default HeaderSection;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/Section/index.tsx